import React from 'react';
import { Award, Target, Users, TrendingUp } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Certified Excellence',
      description: 'Qualified Chartered Accountant with proven expertise in financial services'
    },
    {
      icon: Target,
      title: 'Client-Focused',
      description: 'Dedicated to delivering tailored solutions that meet your unique needs'
    },
    {
      icon: Users,
      title: 'Trusted Advisor',
      description: 'Building long-term relationships through transparency and integrity'
    },
    {
      icon: TrendingUp,
      title: 'Growth Partner',
      description: 'Helping businesses achieve sustainable financial growth and success'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://customer-assets.emergentagent.com/job_emergent-ca-build/artifacts/r9svxsnb_WhatsApp%20Image%202026-02-15%20at%2013.09.41.jpeg"
                alt="CA Pankaj Goyal"
                className="rounded-2xl shadow-2xl w-full max-w-md mx-auto h-auto object-cover"
              />
              <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white p-8 rounded-xl shadow-2xl">
                <p className="text-4xl font-bold">CA</p>
                <p className="text-sm mt-1">Pankaj Goyal</p>
              </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full bg-teal-600/5 rounded-2xl -z-10 transform translate-x-6 translate-y-6"></div>
          </div>

          {/* Right - Content */}
          <div className="space-y-6">
            <div>
              <span className="text-teal-600 font-semibold text-sm uppercase tracking-wide">About Me</span>
              <h2 className="text-4xl font-bold text-slate-900 mt-3 mb-4">
                Your Trusted Partner for Financial Excellence
              </h2>
            </div>

            <p className="text-lg text-slate-600 leading-relaxed">
              As a professionally dedicated Chartered Accountant, I provide comprehensive financial services to both domestic and international clients. With extensive experience in taxation, audit, and business advisory, I am committed to delivering sound and effective solutions that drive your financial success.
            </p>

            <p className="text-lg text-slate-600 leading-relaxed">
              My practice offers a wide range of services including direct and indirect tax consultancy, auditing and assurance services, statutory compliances, business registration, GST services, and strategic financial advisory. I believe in building lasting relationships with clients through transparency, integrity, and professional excellence.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-6 pt-6">
              {features.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div 
                    key={index}
                    className="group p-6 rounded-xl bg-slate-50 hover:bg-teal-50 transition-all duration-300 hover:shadow-lg"
                  >
                    <div className="bg-teal-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors">
                      <IconComponent className="w-6 h-6 text-teal-700 group-hover:text-white transition-colors" />
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-2">{feature.title}</h3>
                    <p className="text-slate-600 text-sm">{feature.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
